import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=6fa79228&"
import script from "./Password.vue?vue&type=script&lang=ts&"
export * from "./Password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports